<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.price_after }}</td>
          <td class="text-xs-right">{{ props.item.client_name }}</td>
          <td class="text-xs-right">{{ props.item.taslim_date }}</td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
          <td class="text-xs-right">
            {{ props.item.store ? props.item.store.name : "" }}
          </td>
          <td class="justify-center layout px-0">
            <v-icon small class="ml-4" @click="detailItem(props.item)">
              book
            </v-icon>
          </td>
          <td style="padding:0px">
            <v-btn
              small
              color="orange"
              style="margin:0px;padding:0px"
              @click.prevent="solmt_confirm(props.item)"
            >
              <!-- @click="confirm_fatwora" -->
              تاكيد
            </v-btn>
            <v-btn
              small
              color="red"
              style="margin:4px 0px;padding:0px"
              @click.prevent="solmt_reject(props.item)"
            >
              <!-- @click="confirm_fatwora" -->
              رفض
            </v-btn>
          </td>
          <td>
            <textarea v-model="props.item.reason" name="" id=""></textarea>
          </td>
          <td>
            <router-link :to="'/FinalFatworasPrint/' + props.item.id"
              ><v-icon>print</v-icon></router-link
            >
          </td>
          <td>
            <v-icon
              style="curser:pointer"
              v-if="permissions.delete_all == 1 || user.type == 1"
              @click="delete_fatwora(props.item)"
              >delete</v-icon
            >
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>

    <v-container>
      الفواتير المؤكد عليها سابقا

      <v-data-table
        :headers="headers5"
        :items="fatworas_done"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status == 4
                ? { 'background-color': 'yellow' }
                : { 'background-color': 'red' }
            ]"
          >
            <td>{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.price_after }}</td>
            <td class="text-xs-right">{{ props.item.client_name }}</td>
            <td class="text-xs-right">{{ props.item.taslim_date }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="text-xs-right">
              {{ props.item.store ? props.item.store.name : "" }}
            </td>
            <td class="justify-center layout px-0">
              <v-icon small class="ml-4" @click="detailItem(props.item)">
                book
              </v-icon>
            </td>

            <td>
              <router-link :to="'/FinalFatworasPrint/' + props.item.id"
                ><v-icon>print</v-icon></router-link
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary">Reset</v-btn>
        </template>
      </v-data-table>
    </v-container>

    <v-dialog v-model="detail_dialog" width="800" dark style="padding:10px">
      <v-card>
        <v-card-title class="headline orange lighten-2" primary-title>
          تفاصيل الفاتورة
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4>
              الكود :
              {{ item_detail.code }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              المندوب :
              {{
                item_detail.client && item_detail.client.mandob_sales
                  ? item_detail.client.mandob_sales.name
                  : ""
              }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              اسم العميل :
              {{ item_detail.client_name }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              المديونية السابقة :
              {{ item_detail.madionia_sabqa }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              المديونية الحالية :
              {{ item_detail.madionia_now }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              السعر قبل :
              {{ item_detail.price_before }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              السعر بعد :
              {{ item_detail.price_after }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              نوع السداد :
              {{ item_detail.sdad_type_name }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              موظف عمل الفاتورة :
              {{ item_detail.emp_create_fatwora }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              تاريخ التسليم :
              {{ item_detail.taslim_date }}
            </v-flex>
          </v-layout>
          <hr />
          <v-data-table
            :headers="headers3"
            :items="item_detail.fatwora_items"
            class="elevation-1"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.item_name }}</td>
              <td>{{ props.item.item_num }}</td>
              <td>{{ props.item.item_num_after }}</td>
              <td>{{ props.item.item_bonus }}</td>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="detail_dialog = false">
            موافق
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  solmt_fatworas,
  solmt_confirm,
  solmt_reject,
  delete_fatwora_client_before_store,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    dialog: false,

    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    item_detail: {},
    detail_dialog: false,

    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    headers: [
      {
        text: "الكود ",
        align: "right",
        value: "code"
      },
      { text: "السعر ", value: "price_after", align: "right" },
      { text: " اسم العميل", value: "client_name", align: "right" },
      { text: "  تاريخ التسليم", value: "taslim_date", align: "right" },
      { text: "التاريخ", value: "taslim_date", align: "right" },
      { text: " المخزن", value: "store", sortable: false, align: "right" },
      { text: " تفاصيل", value: "store", sortable: false, align: "right" },
      { text: " تأكيد", value: "store", sortable: false, align: "right" },
      { text: " سبب الرفض", value: "store", sortable: false, align: "right" },
      { text: " تعين وطباعة", value: "store", sortable: false, align: "right" },
      { text: "حذف ", value: "store", sortable: false, align: "right" }
    ],
    headers5: [
      {
        text: "الكود ",
        align: "right",
        value: "code"
      },
      { text: "السعر ", value: "price_after", align: "right" },
      { text: " اسم العميل", value: "client_name", align: "right" },
      { text: "  تاريخ التسليم", value: "taslim_date", align: "right" },
      { text: "التاريخ", value: "taslim_date", align: "right" },
      { text: " المخزن", value: "store", sortable: false, align: "right" },
      { text: " تفاصيل", value: "store", sortable: false, align: "right" },
      { text: " تعين وطباعة", value: "store", sortable: false, align: "right" }
    ],
    headers3: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      { text: " العدد", value: "client_name", sortable: false, align: "right" },
      {
        text: " العدد النهائي",
        value: "item_num_after",
        sortable: false,
        align: "right"
      },
      {
        text: "   البونص",
        value: "item_bonus",
        sortable: false,
        align: "right"
      }
    ],

    fatworas: [],
    fatworas_done: []
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    solmt_fatworas().then(response => {
      this.fatworas = response.data.fatworas;
      this.fatworas_done = response.data.fatworas_done.data;
      this.pagination.totalItems = response.data.fatworas.length;
      this.loading = false;
    });
  },

  methods: {
    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
    },

    solmt_confirm(item) {
      var frmData = new FormData();
      let myUser = JSON.parse(localStorage.getItem("user"));
      frmData.append("emp_fatwora_solmt", myUser.name);
      this.loading = true;
      solmt_confirm(item.id, frmData).then(response => {
        this.loading = false;
        const index = this.fatworas.indexOf(item);
        this.fatworas.splice(index, 1);
        let myUser = JSON.parse(localStorage.getItem("user"));
        var frmData3 = new FormData();
        frmData3.append("title", "التاكيد علي فاتورة في حالة سلمت");
        frmData3.append(
          "body",
          "تم التاكيد علي فاتورة في حالة سلمت " +
            this.select_store.name +
            " لفاتورة بكود " +
            item.code +
            " بواسطة " +
            myUser.name
        );
        frmData3.append("type", "solmt_accept");
        frmData3.append("user_id", myUser.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = "التاكيد علي فاتورة في حالة سلمت";
            let mybody =
              "تم التاكيد علي فاتورة في حالة سلمت  " +
              this.select_store.name +
              " لفاتورة بكود " +
              item.code +
              " بواسطة " +
              myUser.name;
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
          }
          setTimeout(() => {
            this.$router.go(0);
          }, 3000);
        });
      });
    },
    solmt_reject(item) {
      var frmData = new FormData();
      frmData.append("reason", item.reason);
      this.loading = true;
      solmt_reject(item.id, frmData).then(response => {
        this.loading = false;
        const index = this.fatworas.indexOf(item);
        this.fatworas.splice(index, 1);
        let myUser = JSON.parse(localStorage.getItem("user"));
        var frmData3 = new FormData();
        frmData3.append("title", "الرفض علي فاتورة في حالة سلمت");
        frmData3.append(
          "body",
          "تم الرفض علي فاتورة في حالة سلمت " +
            this.select_store.name +
            " لفاتورة بكود " +
            item.code +
            " بواسطة " +
            myUser.name
        );
        frmData3.append("type", "solmt_reject");
        frmData3.append("user_id", myUser.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = "الرفض علي فاتورة في حالة سلمت";
            let mybody =
              "تم الرفض علي فاتورة في حالة سلمت  " +
              this.select_store.name +
              " لفاتورة بكود " +
              item.code +
              " بواسطة " +
              myUser.name;
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
            this.$router.push("/SellFatworaReback");
          }
        });
      });
    },
    detailItem(order) {
      this.item_detail = order;
      this.detail_dialog = true;
    },

    delete_fatwora(item) {
      this.$swal({
        title:
          " في هذه المرحلة تأكد من عمل فاتورة مرتجع أولا .. شرط لحذف الفاتورة ان تكون اخر فاتورة لنفس العميل حتي لا تؤثر علي المديونية ..هل تريد الأستمرار ",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.fatworas.indexOf(item);
          this.loading = true;
          delete_fatwora_client_before_store(item.id).then(res => {
            this.loading = false;
            this.fatworas.splice(index, 1);
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
</style>
